import { FieldValues, UseFormRegister } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customRegisterFormField = (register: UseFormRegister<FieldValues>, field: string, options: any = {}): any => {
  const props = register(field, options);
  return { ...props, inputRef: props.ref, elementRef: props.ref };
};

export default customRegisterFormField;
